import { render, staticRenderFns } from "./TopNavLink.vue?vue&type=template&id=0c38a9b0&"
import script from "./TopNavLink.vue?vue&type=script&lang=ts&"
export * from "./TopNavLink.vue?vue&type=script&lang=ts&"
import style0 from "./TopNavLink.vue?vue&type=style&index=0&id=0c38a9b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports